import React from 'react';
import { toast } from 'react-toastify';
import { Button, Typography } from "@mui/material"
import Share from "../../assets/share"
import { useTranslation } from 'react-i18next';

async function shareFn(shareUrl: any, t: any) {
    try {
        await navigator.share({
            title: `WinFacil ${t('Raffle')}:`,
            // text: shareUrl,
            url: shareUrl,
        });
    } catch (err) {
        // El usuario puede haber cancelado el share nativo
        // console.warn('Compartir cancelado o fallido:', err);
    }
}
export function ShareButton({ itemId }: { itemId: string }) {
    const { t } = useTranslation();

    const handleShare = () => {
        const shareUrl = `${window.location.origin}${window.location.pathname}?id=${itemId}`;
        navigator.clipboard.writeText(shareUrl).then(() => {
            toast.success(t('copiedToClipboard'));
        }).catch(() => {
            // toast.error('No se pudo copiar el enlace.');
        });
        shareFn(shareUrl, t);

    };

    return (
        <Button onClick={handleShare}>
            <Share />
        </Button>
    );
}
